(function($) {
    $(function() {
        var $contactModalBody = $('#contactModal .modal-body');
        var $contactModalTitle = $('#contactModal .modal-title');
        var $contactModalHeader = $('#contactModal .modal-header');

        $('.js-send-mail').on('click', function(e) {
            e.preventDefault();
            var $subject = $(this).data('subject');

            $contactModalTitle.text($subject);
            $('#contactModal .js-msg-subject').val($subject);
            $('#contactModal').modal('show');
        });

        $('#contactForm input, #contactForm textarea').on('keyup change input', function() {
            $(this).removeClass('error');
        });

        $('#contactForm').on('submit', function(e) {
            var $this = $(this);
            e.preventDefault();

            $.ajax({
                type: "post",
                context: this,
                dataType: "json",
                url: delizia_localize.ajaxurl,
                data: {
                    action: "contact_handle",
                    datas: $this.serializeArray(),
                },
                beforeSend: function(data) {
                    $this.find('.btn-text').css('opacity', '0').addClass('loading');
                    $this.find('.preloader').fadeIn(400);
                },
                success: function(response) {
                    $this.find('.btn-text').css('opacity', '1');
                    $this.find('.preloader').fadeOut(400);
                    var $title = delizia_localize.succes_email_send;
                    var $contentModal = $('#contentModal .modal-body');

                    if (!response['fault']) {
                        $('#contactForm').trigger('reset');

                        $contentModal.empty();
                        $contentModal.append('<h1>' + $title + '</h1><p>' + response['msg'] + '</p>');
                        $('#contactModal .fault').text('&nbsp;');
                        $('#contactModal').modal('hide');
                        if (!isEmpty($contentModalScroll)) {
                            $contentModalScroll.refresh();
                        }
                        $('#contentModal').modal('show');
                    } else {
                        $title = delizia_localize.fault;
                        $('#' + response['field']).addClass('error');
                        $('#contactModal .fault').animate({ opacity: 0 }, function() {
                            $(this).text(response['msg'])
                                .animate({ opacity: 1 }).delay(2000).fadeTo(500, 0);
                        });

                    }
                    grecaptcha.reset();
                }
            });
        });

    });
})(jQuery);